module.exports = __webpack_public_path__ + "img/dice-three.5e182dd3.svg";